export let swMessages={
  "privacy_policy_and_terms_of_use":"Privacy Policy and Terms of Use ",
  "privacy_confirm_text":"We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree":"Disagree",
  "privacy_confirm_accept":"Accept",

  "title":"EasyView Personal",
  "title1":"EasyView Pro",
  "user":"E-post",
  "password":"Lösenord",
  "remember":"Kom ihåg mig",
  "forget":"Har du glömt lösenordet?",
  "sign in":"Logga in",
  "login":"Logga",
  "sign up now":"Registrera dig nu",
  "apply":"Ansök nu",
  "contact us":"Kontakta oss",
  "Privacy Policy":"Integritetspolicy",
  "Terms of Use":"Användarvillkor",
  "copyright":"Copyright © 2021 Medtrum Technologies Inc. Med ensamrätt.",

  "chooseLang":"Välj ditt land eller språk",
  "asia":"Asien",
  "europe":"Europa",

  "applyHcp":"Ansök om ett vårdgivarkonto",
  "sign up":"Registrera dig",
  "Patient":"Patient",
  "Caregiver":"Vårdgivare",
  "Email":"E-post",
  "Mobile":"Mobiltelefon",
  "Enter email":"Ange e-postadress",
  "Enter mobile":"Ange mobiltelefonnummer",
  "Verification":"Verifieringskod",
  "Invitation":"Invitation code",
  "full name":"Ange ditt fullständiga namn",
  "Enter pass":"Ange lösenord",
  "org":"Organisation",
  "Register":"Register",
  "send":"Skicka",
  "agree":"Jag har läst och godkänner ",
  "privacy":" Medtrums integritetspolicy  ",
  "and" :"och ",
  "use":"användarvillkor.",
  "errtip1-1":"Du måste ange en giltig e-postadress. Den ",
  "errtip1-2":"blir ditt användarnamn på Medtrum.",
  "errtip2":"Please enter a valid mobile number.",
  "errtip3":"Felaktig verifieringskod",
  "errtip4":"Incorrect invitation code.",
  "errtip5":"Felaktigt användarnamn",
  "errtip6":"Your password must have 8 or more characters.",
  "errtip7":"Ange din organisation.",

  "errp1":"Lösenordet måste innehålla minst tre av följande:",
  "errp2":"versal, gemen, siffra eller specialtecken.",
  "errp3":"Lösenordet måste vara mellan 6 och 20 tecken långt.",
  "errp4":"Lösenordet får inte vara identiskt med användarnamnet.",
  "errp5":"Lösenordet får inte ha tre identiska siffror i följd (t.ex. 123, 321).",
  "errp6":"Lösenordet får inte ha tre identiska bokstäver i följd (t.ex. abc, cba).",
  "errp7":"Lösenordet får inte innehålla mellanslag.",


  "Find account":"Återskapa ditt lösenord.",
  "Enter username":"Ange ditt användarnamn.",
  "Next":"Nästa",
  "Cancel":"Avbryt",
  "Back":"Tillbaka",
  "Enter veri":"Verifieringskod",
  "Verify notice":"Vi har skickat verifieringskoden via e-post.",
  "Create new":"Skapa ett nytt lösenord",
  "Create new notice":"Skapa ett nytt lösenord. Det måste ha minst 6 tecken.",
  "New pass" :"Nytt lösenord",
  "Completed":"Slutfört",
  "Created":"Det nya lösenordet har skapats.",
  "Login Now":"Logga in nu",

  "Delete":"Ta bort",
  "New Patient":"Ny patient",
  "Add Patient":"Lägg till patient",
  "Filter":"Filter",
  "Name":"Namn",
  "Gender":"Kön",
  "Age":"Ålder",
  "Type":"Typ",
  "Duration":"Varaktighet",
  "Connections":"Kontoskapare",
  "UploadTime":"Uppladdningstid",
  "Year":"år",
  "Years":"år",
  "Month":"månad",
  "Month2":"Månad",
  "Months":"månad",
  "Invite":"Bjud in",
  "Invited":"Inbjuden",
  "All":"Alla",
  "Female":"Kvinna",
  "Male":"Man",
  "Not Set":"Ej angivet",
  "Type 1":"Typ 1",
  "Type 2":"Typ 2",
  "Gestational":"Graviditet",
  "Prediabetes":"Prediabetes",
  "LADA":"Typ 1,5 LADA",
  "Apply":"Använd",
  "disUn":"Diabetestyp ej specificerad",
  "ageUn":"Ålder ej specificerad",
  "genUn":"Kön ej specificerat",
  "addP":"Lägg till patient",
  "newP":"Ny patient",
  "findP":"Sök efter en patient",

  "GDRNF":"Ej angivet",
  "GDRF":"Kvinna",
  "GDRM":"Man",
  "女":"Man",

  "DBTNF":"Ej angivet",
  "DBT1":"Typ 1",
  "DBT2":"Typ 2",
  "DBTLADA":"Typ 1.5 LADA",
  "DBTPRE":"Prediabetes",
  "DBTGEST":"Graviditet",
  "前期":"beFore",
  "beFore":"beFore",
  "MODY":"Mody",

  "No selection":"Ej angivet",
  "unspecif":"Ej angivet",
  "register":"Patient",
  "hcp":"Kliniker",

  "BG":"BS",
  "CARB":"Kolhydrater",
  "INS":"Injektion",
  "EXR":"Träning",
  "OTR":"Övriga",
  "HBA1C":"HbA1c",
  "DOSE":"DOSE",
  "URINEK":"Urinketon",
  "HEL":"HEL",
  "OTR1":"Övrigt",
  "Loading":"Laddar",

  "home":"Hem",
  "pID":"Patient-ID",
  "fullName":"Fullständigt namn",
  "gender":"Kön",
  "height":"Längd",
  "weight":"Vikt",
  "cm":"cm",
  "kg":"kg",
  "birthday":"Födelsedatum",
  "disType":"Typ av diabetes",
  "disDate":"Diagnosdatum",
  "Address":"Adress",
  "Postcode":"Postnummer",
  "Inpatient":"Sluten vård",
  "Yes":"Ja",
  "No":"Nej",
  "Pno":"Patientnummer",
  "Bno":"Sängnummer",
  "create":"Skapa",
  "Telephone":"Telefon",

  "enterU":"Ange användarnamn (e-postadress)",
  "search":"Sök",
  "noU":"Du måste ange ett användarnamn.",
  "searchR":"Sökresultat",
  "uername":"Användarnamn",
  "alias":"Alias",
  "remove":"Ta bort",
  "viewG":"Visa diagram",
  "sendR":"Skicka begäran",
  "rSent":"Din begäran har skickats.",
  "cancelR":"Avbryt begäran",

  "VcodeTip1":"Har du inte fått det? Vänta i en minut och ",
  "VcodeTip2":"försök igen.",
  "VcodeTip3":"Vi har just skickat en verifikationskod till ",
  "Entercode":"Ange kod",
  "Getcode":"Hämta kod",

  "messages":"Meddelanden",
  "profile":"Profil",
  "sign out":"Logga ut",
  "changeP":"Byt lösenord",
  "connection":"Connections",

  "myP":"Min profil",
  "Portrait":"Profilbild",
  "Profession":"Yrke",
  "DPRONF":"Ej angivet",
  "DPROENDOCRIN":"Endokrinolog",
  "DPRODIABTRA":"Diabetesupplysare",
  "DPRONURSE":"Sjuksköterska",
  "DPRODIATIT":"Dietist",
  "DPROOTR":"Andra vårdgivare",
  "Organization":"Organisation",
  "Bio":"Bio",
  "save":"Spara",
  "oldPa":"Gammalt lösenord ",
  "newPa":"Nytt lösenord",
  "RePa":"Ange lösenordet igen",
  "forgetY":"Har du glömt lösenordet?",
  "applyM":"Använd",
  "oldErr":"Det gamla lösenordet är felaktigt.",
  "EntTheSame":"Ange det nya lösenordet igen.",
  "EnterOld":"Ange det gamla lösenordet.",

  "pList":"Patientlista",
  "connections":"Anslutningar",
  "settings":"Inställningar",
  "monitor":"Övervaka",
  "graphs":"Rapporter",
  "events":"Händelser",
  "records":"Poster",
  "qPrint":"Snabbutskrift",

  "sensorIn":"Sensorinformation",
  "timeOfLaRead":"Tid för senaste sensoravläsning",
  "tranSn":"Sändarens serienr",
  "status":"Status",
  "sensorLife":"Sensorns återstående användningstid",
  "lastSenorRead":"Senaste sensoravläsning",
  "TranBattery":"Sändarens batteri",
  "sg":"SG",
  "alert":"Varning",
  "target":"Mål",
  "hypo":"Hypo",
  "sensorGlucose":"Sensorglukos",
  "calib":"Kalibrering",
  "newSen":"Ny sensor",
  "warm":"Uppvärmning",
  "InsulinPump":"Insulinpump",
  "timeOfLaPump":"Tid för senaste pumpdata",
  "pumpSN":"Pumpbasens serienr",
  "ReserviorLife":"Återstående användningstid för reservoarpatchen",
  "InsulinLeft":"Återstående insulin",
  "basal":"Basal",
  "bolus":"Bolus",
  "totalBasal":"Total daglig basal",
  "lastBolus":"Senaste bolus",
  "activeInsulin":"Aktivt insulin",
  "totalBolus":"Total daglig bolus",
  "tampBasal":"Temporär basal",
  "normalBolus":"Normal bolus",
  "extendBolus":"Förlängd bolus",
  "manualStop":"Stoppa manuellt",
  "autoStop":"Stoppa automatiskt",
  "auto suspend":"Stoppa automatiskt",
  "stop":"Leveransstopp",
  "newPatch":"Ny patch",
  "tempBasal":"Temporär basal",
  "N":"N",
  "E":"F",
  "CN1":"KN",
  "CE":"KF",

  "staticSettings":"Rapportinställningar",
  "dataSource":"Datakälla",
  "unit":"Enhet",
  "glucoseTarget":"Målintervall för blodsocker",
  "overall":"Övergripande",
  "Hypoglycemia":"Hypoglykemi",
  "timePeriod":"Tidsperiod",
  "postMeal":"Analys efter måltid",
  "Breakfast":"Frukost",
  "Lunch":"Lunch",
  "Dinner":"Kvällsmat",
  "night":"Natt",
  "Before":"Före",
  "After":"Efter",
  "Low":"Lågt",
  "High":"Högt",
  "From":"Från",
  "To":"Till",
  "Hours":"timmar",
  "Reset":"Återställ standardvärden",
  "RealTime":"Realtid",
  "uploaded":"Uppladdat",
  "sensor":"Sensor",
  "pdmSN":"PDM-serienr",
  "startTime":"Starttid",
  "endTime":"Sluttid",
  "uploadTime":"Överföringstid",
  "pdm":"PDM",
  "Uploaded":"Uppladdat",
  "Patch Pump":"PDM",
  "overLapp":"Sessionerna överlappar",
  "showAlert":"Visa varningar",

  "dashboard":"Sammanställning",
  "dboard_glucose_statistics":"Glucose Statistics",
  "dboard_glucose":"Glucose",
  "dboard_cgm":"CGM",
  "dboard_insulin":"Insulin",
  "dboard_carbs":"Carbs",
  "dboard_exercise":"Exercise",
  "dboard_glucose_avg":"Average",
  "dboard_cgm_avg":"Medelvärde",
  "dboard_insulin_avg":"Average Daily Dose",
  "dboard_carbs_avg":"Genomsnittliga kolhydrater/dag",
  "dboard_exercise_avg":"Genomsnittlig tid/dag",
  "dboard_sd":"SD",
  "dboard_num":"#",
  "dboard_num_days":"# days",
  "dboard_statistics":"Statistics",
  "dboard_BG":"BG",
  "dboard_BG_calibration":"BG / calibration (per day)",
  "dboard_SG":"SG",
  "dboard_AUC_high":"AUC high >",
  "dboard_AUC_low":"AUC low <",
  "dboard_highest_value":"Högsta värde (mmol/L)",
  "dboard_lowest_value":"Lägsta värde (mmol/L)",

  "dboard_pump":"Pump",
  "dboard_avg_daily_dose":"Genomsnittlig daglig dos",
  "dboard_SD":"SD",
  "dboard_daily_basal":"Daglig Basaldos ",
  "dboard_daily_bolus":"Daglig Bolusdos ",
  "dboard_avg_bolus_num":"Genomsnittligt antal bolusdoser/dag",
  "dboard_avg_suspend_time":"Genomsnittlig Stoppad tid",
  "dboard_avg_reservoir_usage":"Genomsnittlig användning av Patch	",
  "dboard_days":"days",

  "dboard_manual_bolus":"Manuella bolussdoser (mängd/ antal/dag)",
  "dboard_normal":"-Normal",
  "dboard_extend":"-Förlängd",
  "dboard_combo":"-Kombibolus",

  "dboard_bolus_calculator":"Boluskalkylator (mängd/antal/dag)",
  "dboard_food_bolus":"-Måltidsboluskalk.",
  "dboard_corr_bolus":"-Korr.Boluskalk.",
  "dboard_override_add":"Öka föreslagen bolus",
  "dboard_override_sub":"Minska föreslagen bolus",

  "dboard_report":"Sammanställning Rapport",

  "daily":"Daglig sammanfattning",
  "date":"Datum",
  "print":"Skriv ut",
  "carbs":"Kolhydrater",
  "exercise":"Träning",
  "heavy":"Hård",
  "Medium":"Medelhård",
  "Light":"Lätt",
  "dailyReport":"Daglig sammanfattningsrapport",
  "devices":"Enheter",
  "tran":"Sändare",
  "pumpBase":"Pumpbas",
  "HbA1c":"HbA1c",
  "statics":"Statistik",
  "glucose":"Blodsocker",
  "item":"Objekt",
  "BG1":"BS",
  "SG1":"SG",
  "avgSD":"Medelvärde (mmol/L)±SD",
  "avgSD1":"Medelvärde ± SD",
  "min":"Min",
  "max":"Max",
  "ofRead":"# avläsningar",
  "ofHypo":"# hypo/varaktighet(min)",
  "ofAlert":"# varningar",
  "insulin":"Insulin",
  "insulin2":"Insulin",
  "totalDose":"Total daglig dos",
  "foodBolus":"Måltidsbolus",
  "Food+coor":"Food+corr",
  "calibBolus":"Korrektionsbolus",
  "durationStop":"Stoppvaraktighet(min)",
  "ofPumpAlert":"# pumpalarm",
  "ofMeal":"# måltider",
  "totalExerTime":"Total träningstid",
  "exerNum":"# träningstillfällen",
  "avgInten":"Genomsnittlig intensitet",
  "target1":"Mål",
  "high1":"Högt",
  "low1":"Lågt",
  "BG Reading":"BS-avläsningar",

  "dayByday":"Översikt, dag för dag",
  "dayBydayRe":"Översiktsrapport, dag för dag",
  "period":"Period",

  "sensorOverlay":"Sensoröverlagring",
  "set":"Ställ in",
  "setPeriod":"Ställ in period",
  "Weekdays":"Vardagar",
  "Weekends":"Helger",
  "Mon":"Mån",
  "Tue":"Tis",
  "Wed":"Ons",
  "Thur":"Tors",
  "Thu":"Tors",
  "Fri":"Fre",
  "Sat":"Lör",
  "Sun":"Sön",
  "Average":"Medelvärde",
  "sensorOlRe":"Sensoröverlagringsrapport",
  "Avg":"Medelvärde",
  "±SD":"±SD",
  "ofhypo":"# of Hypo",
  "Everyday":"varje dag",

  "TrendAna":"Trendanalys",
  "TrendRe":"Trendanalysrapport",
  "sensorGlu":"Sensorglukos ",
  "ofBGtest":"# BS-tester",
  "Basics":"Grundläggande",
  "static":"Statistik",
  "Med":"Med",
  "med":"medelvärde",
  "Q1":"Q1",
  "Q3":"Q3",
  "Q11":"Q1",
  "Q31":"Q3",
  "IQR":"IQR",
  "SD":"SD",
  "CV":"CV",
  "SE1":"SE",
  "distri":"Distribution",
  "stab":"Stabilitet",
  "#high":"# högt",
  "#low":"# lågt",
  "aucBelow":"AUC under",
  "aucAbove":"AUC över",
  "bgRead":"BS-avläsningar",
  "total":"Totalt",
  "ofBolus":"# bolus",
  "avgBolus":"Gen. bolus",
  "Dura1":"Varaktighet (min)",
  "Avg/Total":"Medelvärde/totalt",
  "high":"Högt",
  "low":"Lågt",
  "#hypo":"# hypo",
  "ofExer":"# träningstillfällen",

  "logbook":"Loggbok",
  "dailyTotal":"Totalt per dag",
  "High Glucose":"Högt blodsocker",
  "Low Glucose":"Lågt blodsocker",
  "No Active Patch":"Ingen aktiv patch",
  "Missed Meal":"Missad måltid",
  "Multiple BG Readings":"Flera BS-avläsningar",
  "Stop Patch":"Stoppa patch",
  "Others":"MODY",
  "Other Events":"Andra händelser",
  "logRe":"Loggboksrapport",

  "DeviceSetting":"Granska enhetsinställningar",
  "Insulin Pump":"Insulinpump",
  "MaxBasalRate":"Maximal basalhastighet",
  "BasalPatterns":"Basalmönster",
  "Selected Basal Pattern":"Valt basalmönster",
  "Maximum Bolus":"Maximal bolus",
  "Combo/Extended Bolus":"Dubbel/förlängd bolus",
  "BG Reminder":"BS-påminnelse",
  "Bolus Increment":"Bolusökning",
  "Bolus Calculator":"Boluskalkylator",
  "Active Insulin Time":"Aktiv insulintid",
  "IC Ratios":"IK-förhållande",
  "Insulin Sensitivity":"Insulinkänslighet",
  "BG Target":"BS-mål",
  "Bolus Reminder":"Boluspåminnelse",
  "CGM":"CGM",
  "CGM System":"CGM-system",
  "Glucose Unit":"Glukosenheter",
  "Glucose Limits":"Blodsockergränser",
  "Predicitive Alerts":"Förebyggande varningar",
  "Rate Alerts":"Hastighetsvarningar",
  "type":"Typ",
  "time":"Tid",
  "data":"Data",
  "Rate":"Rate",
  "Calibration Reminder":"Kalibreringspåminnelse",
  "Calibration Repeat":"Kalibreringsupprepning",
  "Snooze":"Snooze",
  "Audio Options":"Ljudalternativ",
  "Confidence Reminder":"Användningsfeedback",
  "Backlight":"Bakbelysning",
  "Sec":"sek",
  "Alarm Clock":"Väckarklocka",
  "Patch Expiration":"Utgång för patch",
  "Sensor Expiration":"Utgång för sensor",
  "Hourly Max":"Max per timme",
  "Daily Max":"Max per dag",
  "Low Reservoir":"Låg reservoar",
  "Low Suspend":"Stopp vid lågt värde",
  "Predictive Low Suspend":"Beräknat stopp vid lågt värde",
  "Rise":"Ökning",
  "Fall":"Minskning",
  "Auto Off":"Automatisk avstängning",
  "Standard":"Standard",
  "Exercise":"Träning",
  "Holiday":"Helgdag",
  "ProgramA":"Mönster A",
  "ProgramB":"Mönster B",
  "--":"--",
  "Insulin":"Insulin",

  "SUSA":"Automatisk avstängning",
  "SUSHM":"Överskrider max. leveransmängd under 1 timme",
  "SUSDM":"Överskrider max. TDD",
  "SUSLSG":"Stopp vid lågt värde",
  "SUSPLSG":"Beräknat stopp vid lågt värde",
  "Pump Restarted":"Pumpen har startat om",
  "Meter BG Now":"Mät blodsocker nu",
  "Sensor Exp in 2 Hours":"Sensor utgår om 2 timmar",
  "Sensor Exp in 6 Hours":"Sensor utgår om 2 timmar",
  "Sensor Exp in 30 Min":"Sensor utgår om 30 min",
  "Sensor Calibration Error":"Sensorkalibreringsfel",
  "Sensor Error":"Inga avläsningar",

  "Device Settings Report":"Enhetsinställningsrapport",
  "24h Total":"Dygnstotal",
  "Device Settings at":"Enhetsinställningar,",
  "Start":"Start",
  "Combo/Ext Bolus":"Dubbel/förlängd bolus",
  "Time Format":"Tidsformat",
  "Device Options（CGM System)":"Enhetsalternativ (CGM-system)",
  "Device Options（Insulin Pump)":"Enhetsalternativ (insulinpump)",
  "Dispay Settings (Screen)":"Visningsinställningar (skärm)",
  "Dispay Settings (Backlight)":"Visningsinställningar (bakbelysning)",
  "Graph Range":"Diagramintervall",
  "Range":"Range",
  "Repeat":"Upprepning",
  "Glucose Alerts":"Blodsockervarningar",
  "Alert Silence":"Varning tyst",

  "Create":"Skapa",
  "Event Filter":"Händelsefilter",
  "HbA1c1":"HbA1c",
  "Urine Ketone":"Urinketon",
  "Injection":"Injektion",
  "Other":"Övrigt",
  "Event Type":"Händelsetyp",
  "Details":"Information",
  "Notes":"Anteckningar",
  "Source":"Källa",
  "edit":"Redigera",
  "Action":"Åtgärd",
  "EventReport":"Händelsesammanfattningsrapport",
  "By Date":"Efter datum",
  "By Category":"Efter kategori",
  "Event Summary":"Händelsesammanfattning",
  "No data":"Inga data",
  "No1":"Inga",
  "data1":"data",
  "#":"#",
  "BG Summary":"Blodsockersammanfattning",
  "Carbs Summary":"Kolhydratsammanfattning",
  "Injection Summary":"Injektionssammanfattning",
  "Exercise Summary":"Träningssammanfattning",
  "Input Notes":"Ange en anteckning",

  "Profile":"Profil",
  "Complications":"Komplikationer",
  "Concomitant diseases":"Samtidiga sjukdomar",
  "Suggestion":"Förslag",
  "Coronary heart disease":"Kranskärlssjukdom",
  "High blood lipids":"Förhöjda blodfetter",
  "High blood pressure":"Högt blodtryck",
  "Kidney disease":"Njursjukdom",
  "Neuropathy":"Neuropati",
  "Obesity":"Fetma",
  "Peripheral arterial disease":"Perifer artärsjukdom",
  "Retinopathy":"Näthinnesjukdom",
  "Smoking addiction":"Rökare",
  "Enter date":"Ange datum",
  "Enter suggestion":"Ange förslag",
  "Enter Notes":"Lägg till anteckning",
  "Select":"Välj",
  "Prescription":"Ordination",
  "Medicine":"Läkemedel",
  "Dose":"Dos",
  "Enter medicine":"Ange läkemedel",
  "Enter dose":"Ange dos",
  "Enterdis":"Ange  samtidiga sjukdomar",
  "Add note":"Lägg till anteckning",
  "Add Content":"Den maximala längden är 1 000 tecken.",
  "Other suggestions":"Andra förslag",
  "OK":"OK",
  "HCP":"Vårdgivare",
  "Content":"Innehåll",
  "Records Report":"Postrapport",

  "Quick Print":"Snabbutskrift",
  "Quick Print Settings":"Inställningar för snabbutskrift",
  "Select duration":"Välj varaktighet",
  "One Week":"En vecka",
  "One Month":"En månad",
  "One Quarter":"Ett kvartal",
  "End date":"Slutdatum",
  "Yesterday":"I går",
  "Last Sunday":"Föregående söndag",
  "Last Saturday":"Föregående lördag",
  "Last Day of Last Month":"Last Day of Last Month",
  "Last Day of Last Quarter":"Last Day of Last Quarter",
  "Customized":"Anpassad",
  "Week Filter":"Veckofilter",
  "Select reports to print":"Välj rapporter som ska skrivas ut",
  "Daily Summary":"Daglig sammanfattning",
  "Day By Day Overview":"Översikt, dag för dag",
  "Sensor Overlay":"Sensoröverlagring",
  "Trend Analysis":"Trendanalys",
  "Logbook":"Loggbok",
  "Device Settings Review":"Granska enhetsinställningar",
  "createReport":"Skapa rapport",

  "Segment Analysis":"Segmentanalys",
  "Sensor Glucose Profile":"Sensorglukosprofil",
  "# of Boluses":"# bolus",
  "Bolus Insulin":"Bolusinsulin ",
  "Basal Pattern":"Basalmönster ",
  "Segment Analysis Report":"Segmentanalysrapport",
  "Avg Glucose":"Glukosmedelvärde",
  "Below":"Under",
  "In Target Range":"I målintervallet",
  "Coefficient of variation":"Variationskoefficient",
  "% Time CGM Active":"% tid då CGM var aktiv",
  "est_a1c_t1":"Estimated A1C:",
  "est_a1c_t2":"calculated from SG values",
  "est_a1c_t3":"Obs: Beräknat HbA1c ersätter inte provtagning på sjukhus HbA1c med det laboratoriskt prov.",

  "acceptTip":" har tillåtit att du fjärrvisar dennes hälsoinformation. ",
  "cancelTip":" tillåter inte längre att du fjärrvisar dennes hälsoinformation. Du kan ansöka igen vid behov.",
  "rejectTip":" har avböjt din ansökan om fjärrvisning.",
  "Read":"Läs",

  "Connection":"Anslutning",
  "connections1":"Anslutning",
  "Add Connection":"Lägg till anslutning",
  "SG":"SG",
  "Active Insulin":"Aktivt insulin",
  "Stop following":"Sluta följa",
  "Enter username (email)":"Ange användarnamn (e-postadress)",
  "Search results":"Sökresultat",
  "Send request":"Skicka begäran",
  "View graphs":"Visa diagram",
  "Agree":"Godkänn",
  "Deny":"Avböj",
  "Remove":"Ta bort",
  "Cancel Requset":"Avbryt begäran",
  "Remark":"Anteckning",

  "Warm up":"Uppvärmning",
  "Monitoring":"Övervakning",
  "Transmitter Error":"Sändarfel",
  "Sensor Failure":"Sensorfel",
  "Sensor Expired":"Sensor har utgått",
  "Lost Sensor":"Förlorad sensor",
  "Not Calibrated":"Ej kalibrerad",
  "Calibrating":"Kalibrerar",
  "Calibration Needed":"Kalibrering krävs",
  "Calibration Error":"Kalibreringsfel",
  "Charging Battery":"Laddar batteri",
  "Battery Charged":"Batteri laddat",

  "To be filled":"Ska fyllas",
  "Filled with insulin":"Fylld med insulin",
  "Priming":"Primar",
  "Priming completed":"Primning slutförd",
  "Inserting needle":"För in nål",
  "Patch activated":"Patch aktiverad",
  "Delivering Basal":"Levererar basal",
  "Exceeds Max 1 Hour Delivery":"Överskrider max. leveransmängd under 1 timme",
  "Exceeds Max TDD":"Överskrider max. TDD",
  "Suspend":"Stoppa",
  "Occlusion Detected":"Ocklusion upptäckt",
  "Patch Expired":"Patch har utgått",
  "Empty Reservoir":"Reservoar tom",
  "Patch Error":"Patchfel",
  "Pump Base Error":"Pumpbasfel",
  "Patch Battery Depleted":"Patch-batteri tomt",
  "Magnetic sensor not calibrated":"Magnetisk sensor ej kalibrerad",

  "Patient Profile":"Patientprofil",

  "On":"På",
  "on":"På",
  "Off":"Av",
  "off":"Av",

  "CORONARY_HEART_DISEASE":"Kranskärlssjukdom",
  "HIGH_BLOOD_LIPIDS":"Förhöjda blodfetter",
  "HIGH_BLOOD_PRESSURE":"Högt blodtryck",
  "KIDNEY_DISEASE":"Njursjukdom",
  "NEUROPATHY":"Neuropati",
  "OBESITY":"Fetma",
  "PERIPHERAL_ARTERIAL_DISEASE":"Perifer artärsjukdom",
  "RETINOPATHY":"Näthinnesjukdom",
  "SMOKING_ADDICTION":"Rökare",

  "saveTip":"Sparat.",
  "changePaTip":"Lösenordet har ändrats.",
  "enterEmTip":"Ange din e-postadress.",
  "verErrTip":"Felaktig verifieringskod.",
  "chooseEventTip":"Välj händelser som ska skrivas ut",
  "chooseDataTip":"Välj data att skriva ut",
  "dateWrongTip":"Slutdatumet kan inte vara senare än startdatumet.",
  "infoWrongTip":"Fyll i alla obligatoriska fält.",
  "createdSuccssTip":"Skapad",
  "selectData":"Välj data att spara",

  "acceSu":"Anslutningsbegäran accepterades",
  "acceEr":"Det gick inte att lägga till en ny anslutning",
  "rejeSu":"Anslutningsbegäran avvisades",
  "rejeEr":"Det gick inte att avvisa begäran",

  "userNotExist":"Användarnamnet finns inte.",
  "Password incorrect":"Felaktigt lösenord.",
  "UserType incorrect":"Felaktig användartyp",

  "registSuccess":"Ditt konto har skapats.",
  "registFailed":"Det gick inte att registrera ett nytt konto.",
  "sentSuccess":"Meddelandet har skickats",
  "sentFailed":"Det gick inte att skicka meddelandet",
  "Input error":"Inmatningsfel",

  "deletePtip":"Är du säker på att du vill ta bort de här patienterna?",
  "deleteEvents":"Är du säker på att du vill ta bort de här händelserna?",
  "deleteData":"Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis":"Är du säker på att du vill ta bort den här händelsen?",
  "confirm":"Bekräfta",
  "deleteSuccess":"Borttagen",
  "deleteFailed":"Det gick inte att ta bort objektet",
  "modifySuccess":"Ändringen har genomförts",
  "modifyFailed":"Det gick inte att ändra",
  "createSuccess":"Skapad",
  "createFailed":"Händelsen har skapats",
  "editSuccess":"Händelsen har redigerats.",
  "editFailed":"Det gick inte att redigera händelsen",
  "Time overlapped":"Sessionerna du har valt överlappar varandra.",

  "stopFollow":"Är du säker på att du vill sluta följa denna personen?",
  "CancelTip1":"Är du säker på att du vill ta bort den här anslutningen?",

  "Warning":"Varning",
  "agreeConnect":"Om du klickar på ”Acceptera” för att acceptera anslutningsbegäran blir dina hälsodata tillgängliga via den nya anslutningen.",
  "denyConnect":"Är du säker på att du vill avvisa anslutningsbegäran?",
  "deleteConnect":"Är du säker på att du vill ta bort anslutningen? Om du tar bort den här personen kan denne inte längre visa dina hälsodata.",

  "Choose the events to print":"Välj händelser som ska skrivas ut",
  "tryAgain":"Försök igen",
  "username and password is required":"username and password is required",
  "A name is required":"Du måste ange ett namn.",
  "username is required":"Du måste ange ett användarnamn.",
  "The date choose wrong":"Felaktigt datumval",
  "Date no more than 14 days":"Det går inte att välja mer än 14 dagar.",

  "CancelTip":"Är du säker på att du vill ta bort anslutningen?",
  "removeConnect":"Borttagen",

  "dateErr1":"Det går inte att välja mer än 90 dagar.",
  "dateErr2":"Slutdatumet kan inte vara senare än startdatumet.",

  "Not Filled":"Ej angivet",
  "Today":"I dag",
  "duration":"Varaktighet",
  "interval":"Interval",
  "7 days":"7 dagar",
  "14 days":"14 dagar",
  "30 days":"30 dagar",
  "90 days":"90 dagar",
  "g":"g",

  "Sound+Vibrate":"Ljud + vibration",
  "Sound":"Ljud",
  "Vibrate":"Vibration",
  "Silent":"Stör ej",
  "1":"En gång",
  "2":"Varje dag",
  "noMes":"Det finns inga meddelanden.",
  "noConnect":"Det finns inga anslutningar.",
  "Customize":"Anpassad",
  "GB":"United Kingdom",
  "CN":"China",
  "FR":"France",
  "DD":"Germany",
  "DE":"Germany",
  "SE":"Sweden",
  "AU":"Australia",
  "HKF":"Hongkong",
  "HU":"Hungary",
  "IT":"Italy",
  "NL":"Netherlands",
  "Nor":"Norway",
  "PT":"Portugal",
  "ES":"Spain",
  "TR":"Turkey",

  "Jan":"Jan",
  "Feb":"Feb",
  "Mar":"Mar",
  "Apr":"Apr",
  "May":"Maj",
  "Jun":"Jun",
  "Jul":"Jul",
  "Aug":"Aug",
  "Sep":"Sep",
  "Oct":"Okt",
  "Nov":"Nov",
  "Dec":"Dec",
  "ApplyTip":" förfrågan om att visa dina data.",
  "noReadings":"Inga avläsningar",

  "daop_A6_system":"A6 Touchcare System",
  "daop_easytouch_easyview":"EasyTouch / EasyView iPad",
  "daop_TY012_TY015":"TY012/TY015",
  "daop_easysense":"EasySense",
  "daop_delete_data":"Delete Data",
  "daop_uploaded_data":"Uppladdad Data",
  "daop_uploaded_data_text":"Datan är från EasyTouch App eller EasyView iPad App.",
  "daop_realtime_data":"Realtids Data",
  "daop_realtime_data_text":"The data is from EasySense App or EasyPatch App.",

  "ins_unit":"(E)",
  "ins_unit2":"E",
  "basal_unit":"(E/H)",
  "basal_unit2":"E/H",

  // 告警
  "Alerts_Patch_Battery_Low":"Patch-batteri lågt",
  "Alerts_Patch_Battery_Depleted":"Patch-batteri tomt", // update
  "Alerts_Lost_Pump":"Lost Pump",
  "Alerts_Low_Reservoir":"Låg reservoar", // update
  "Alerts_Empty_Reservoir":"Reservoar tom",
  "Alerts_Patch_Expiration_Advisory":"Meddelande om utgångstid för patch",
  "Alerts_Patch_Exp_In_1_Hour":"Patch Exp In 1 Hour",
  "Alerts_Patch_Expired":"Patch har utgått", // update
  "Alerts_Patch_Error":"Patchfel",
  "Alerts_Pump_Base_Error":"Pumpbasfel",
  "Alerts_Basal_Rate_Key_Error":"Basal Rate Key Error",
  "Alerts_Occlusion_Detected":"Ocklusion upptäckt", // update
  "Alerts_End_Of_Suspend":"End Of Suspend",
  "Alerts_Exceeds_Max_TDD":"Överskrider max. TDD", // update
  //"Alerts_Exceeds_Max_TDD":"Exceeds Max TDD",
  "Alerts_Exceeds_Max_1Hr_Delivery":"Överskrider max. leveransmängd under 1 tim",
  //"Alerts_Exceeds_Max_1Hr_Delivery":"Exceeds Max 1Hr Delivery",
  "Alerts_Predictive_Low_Suspend":"Beräknat stopp vid lågt värde", // update
  "Alerts_Low_Suspend":"Stopp vid lågt värde",
  "Alerts_Auto_Off":"Automatisk avstängning", // update

  "Alerts_Pump_Restart":"Pump Restart",  // 22
  "Alerts_Auto_Off_Warning":"Auto Off Warning",  // 23
  "Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //24
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  // 25
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //33

  "Alerts_Lost_Sensor":"Förlorad sensor", // update
  "Alerts_Transmitter_Battery_Low":"Sändarbatteri lågt",
  "Alerts_Charge_Transmitter":"Ladda sändare",
  "Alerts_Sensor_Error":"Inga avläsningar",
  "Alerts_Transmitter_Error":"Sändarfel",
  "Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  //"Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  "Alerts_Sensor_Failure":"Sensorfel",
  "Alerts_Sensor_Calibration_Reminder":"Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now":"Mät blodsocker nu",
  "Alerts_Sensor_Exp_in_6_Hours":"Sensor utgår om 6 timmar",
  "Alerts_Sensor_Exp_in_2_Hours":"Sensor utgår om 2 timmar", // update
  "Alerts_Sensor_Exp_in_30_Min":"Sensor utgår om 30 min",
  "Alerts_Sensor_Expired":"Sensor har utgått", // update
  "Alerts_Rapid_Rise":"Snabb ökning",
  "Alerts_Rapid_Fall":"Snabb minskning",
  "Alerts_High_Predicted":"Högt beräknat",
  "Alerts_Low_Predicted":"Lågt beräknat",
  "Alerts_High_Glucose":"Högt blodsocker", // update
  "Alerts_Low_Glucose":"Lågt blodsocker", // update
  "Alerts_Below_3.1_mmol/L":"Under 3,1 mmol/l",
  "Alerts_Transmitter_Battery_Low_2":"Sändarbatteri lågt",

  "Alerts_PDM_Battery_Low":"PDM-batteri lågt",
  "Alerts_Replace_Battery":"Ladda din PDM",

  // Alert页面
  "Alert":"Alert",
  "Alerts":"Varningar",
  "Alert Filter":"Alert Filter",
  "PDM":"PDM",
  "Pump":"Pump",
  //"CGM":"CGM",
  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode":"Tid i autoläge",
  "t1221_Average_SG_SD":"Genomsnittlig SG ± SD",
  "t1221_Time_in_Target_Range":"Tid i målintervall(%s)",
  "t1221_Time_above_Range":"Tid över mål",
  "t1221_Time_below_Range":"Tid under mål",
  "t1221_Auto_Basal_per_day":"Auto Basal (per dag)",
  "t1221_Auto_Bolus_per_day":"Auto Bolus (per dag)",
  "t1221_Auto_Mode_Exits":"Avslutade Autoläge",
  "t1221_No_Sensor_readings":"Inga sensor avläsningar",
  "t1221_Max_Delivery":"Max leverans",
  "t1221_Min_Delivery":"Min leverans",
  "t1222_autoModeBasal":"Autoläge Basal",
  "t1222_autoModeCorrBolus":"Autoläge korrigering bolus",
  "t1222_autoSnack":"Auto mellanmål",
  "t1222_autoBreakfast":"Auto frukost",
  "t1222_autoLunch":"Auto lunch",
  "t1222_autoDinner":"Auto middag",
  "t1222_autoExercise":"Auto träning",
  "t1222_Snack":"Mellanmål",
  "t1222_Auto_Mode":"Autoläge",
  "t1222_Time_in_Auto_Mode":"Tid i autoläge(%)",
  "t1222_Avg_SD":"Snitt(mmol/L)±SD",
  "t1222_Target_Range":"Målområde(%)",
  "t1222_Above_Range":"Över målområdet(%)",
  "t1222_Below_Range":"Under målområdet(%)",
  "t1222_Auto_Mode_Exits":"# Autoläge avslutas",
  "t1221_Auto_Mode":"Autoläge",
  "t1222_auto_basal":"Auto Basal",
  "t1222_auto_bolus":"Auto Bolus",
  "t0805_User_Management":"Användarhantering",
  "t0805_Patient_Management":"Patienthantering",
  "t0805_Operation_History":"Operationshistoria",
  "t0805_User_List":"Användarlista",
  "t0805_User":"Användare",
  "t0805_Time":"Tid",
  "t0805_Operation_Type":"Typ av operation",
  "t0805_Back":"Tillbaka",
  "t0805_Add":"Lägg till",
  "t0805_Delete":"Ta bort",
  "t0809_Add_User":"Lägg till användare",
  "t1028_Pattern_C":"Mönster C",
  "t1028_Pattern_D":"Mönster D",
  "t1029_Auto_meal_bolus":"Auto måltidshantering",
  "t1029_Auto_mode_correction_bolus":"Autoläge korrigerings bolus",
  "t1029_Sick":"Sjuk",
  "t1029_Auto_Mode_Feature":"Funktion för autoläge",
  "t1029_Target_SG":"Sensorglukos mål",
  "t1029_Auto_Meal_Handling":"Auto Måltidshantering",
  "t1029_Total_Daily_Dose":"Total daglig dos",
  "t1029_Pump_Light":"Pump Ljus",
  "t1029_Alerts_for_Hypo":"Varningar för Hypo",
  "t1102_Out_of_Range":"Utom räckhåll",
  "t1102_Command_Reminder":"Kommando påminnelse",
  "t1102_Alarms_Alerts_on_APP":"Larm och varningar på Patchpump",
  "t1102_Alarms_on_App":"Larm i App",
  "t1102_Alerts_on_App":"Varningar i App",
  "t1102_Factory_Calibration":"Fabrikskalibrering",
  "t1102_Alerts_for_Low":"Varning för Lågt",
  "t1102_Alerts_for_High":"Varning för Högt",
  "t1102_Alerts_for_Others":"Varning för Övrigt",
  "t1102_Adjustment":"Justering",
  "t1102_Suggested":"Föreslagen",
  "t1103_Glucose":"Blodsocker",
  "t1103_CGM":"CGM",
  "t1103_Insulin":"Insulin",
  "t1103_Carbs":"Kolhydrater",
  "t1103_Exercise":"Träning",
  "t1103_Min_Max":"Min/Max",
  "t1103_Target_Range":"Målområde",
  "t1103_Overall_Tine_In_Range":"Övergripande: Time In Range",
  "t1103_Basal":"Basal",
  "t1103_Bolus":"Bolus",
  "t1103_Basal_Bolus":"Basal & Bolus",
  "t1103_Auto_Mode_Time_In_Range":"Autoläge: Time In Range",
  "t1103_Time_below_range":"Tid under målområde",
  "t1103_Time_above_range":"Tid över målområde",
  "t1103_Time_in_target_range":"Tid i målområde",
  "t1103_Incorrect_Password":"Felaktigt lösenord, $1 Försök kvar, vänligen ange rätt lösenord.",
  "t1103_Incorrect_locked":"Misslyckade försök överskrider gränsen, kontot har låsts. Försök igen om $1 minuter.",
  "t1104_The_data_is_from":"Datan är från EasySense App eller EasyPatch App.",
  "t1104_Privacy_Policy":"Integritetspolicy och användarvillkor",
  "t1104_updated_privacy_policy":"Vi har uppdaterat Integritetspolicy och användarvillkor för tjänsten. Vänligen läs dem noga, EasyPatch kan endast användas efter att alla villkor är överenskomna och accepterade.",
  "t1104_Disagree":"Accepterar inte",
  "t1104_Agree":"Godkänn",
  "t1105_Upload_History":"Uppladdningshistorik",
  "t1105_Delete_Data":"Ta bort data",
  "t1105_Target_Range":"Målområde",
  "t1105_request_to_view_your_data":"$1 begäran om att se dina data.",
  "t1105_Recent_Updates":"Senaste uppdateringar",
  "t1108_No_data":"Inga data",
  "t1108_Pump_Bash_SN":"Pumpbasens serienr",
  "t1108_Transmitter_SN":"Sändarens serienr",
  "t1112_Normal_Glucose":"Normal Glukos",
  "t1112_Manual_Bolus_or_Modified_Bolus":"Manuell bolus eller modifierad bolus",
  "t1112_Auto_Mode_Started":"Autoläge startat",
  "t1112_Auto_Mode_Exit":"Avsluta Autoläge",
  "t1112_Normal_Bolus":"Normal Bolus",
  "t1112_Extended_Bolus":"Förlängd Bolus",
  "t1112_Combo_Bolus":"Kombibolus",
  "t1112_Carbs":"Kolhydrater",
  "t1112_Glucose":"Glukos",
  "t1112_BG":"BG",
  "t1112_Audio":"Ljud",
  "t1112_Tone":"Ljud",
  "t1112_Audio_Options":"Ljudalternativ",
  "t1112_Weight_Unit":"Viktenhet",
  "t1112_Height_Unit":"Höjdenhet",
  "t1112_Not_available":"Inte Tillgänglig",
  "t1112_Number":"Siffra",
  "t1112_days":"# dagar",
  "t1112_min":"min",
  "t1113_days":"dagar",
  "t1215_Security":"Säkerhet",
  "t1215_MFA":"Multifaktorautentisering (MFA)",
  "t1215_Enter_verification_code":"Ange verifieringskod",
  "t1215_Multi_factor_ON":"Multifaktorautentisering är PÅ. Verifieringskoden har skickats till $1 Vänligen skicka in verifieringskoden.",
  "t1215_Verification_code_incorrect":"Felaktig verifieringskod",
  "t1215_Show_Glucose_Value":"Visa glukosvärde",
  "t1221_enter_verification_code":"Ange den sexsiffriga verifieringskoden som skickats till $1.",
  "t1221_Verification_Success":"Verifierad framgångsrikt",
  "t1222_We_will_only_process":"Vi kommer endast att spara din data på Medtrum App/webbplats med ditt medgivande. ",
  "t1222_If_you_are_under_years":"Om du är under 16 år kommer du att behöva medgivande från din förälder eller förmyndare för att registrera dig i denna app.",
  "t1221_register_cn":"Du är inte tvungen att ladda upp data från PDM till App.I detta fall kommer inte uppgifterna att vara tillgängliga för andra. Om du väljer att inte registrera dig på Medtrum app/hemsida så är datan enbart sparad på själva enheten. ",
  "t1221_register_eu":"Om du väljer att registrera dig med ett Medtrum-konto och få tillgång till vår app via kontot, kommer hälsouppgifter som registrerats på appen att laddas upp till vår server i Europa och sparas i 2 år. Du kan välja att inte ladda upp dina data. Du kommer då inte att kunna dela informationen med andra genom följarapp eller via system eller applikationer som sjukvården använder sig av. Om du väljer att inte registrera dig på Medtrum app/hemsida, är datan endast sparad på själva enheten.",
  "t1221_register_follow":"Vi kommer endast att behandla din  data via Medtrum App/webbplats med ditt medgivande.",
  "t1222_Terms_of_Use":"användarvillkoren för Medtrum",
  "t1222_Privacy_Policy":"Medtrums integritetspolicy",
  "t1222_Create_Account":"Skapa konto",
  "t1222_Back":"Tillbaka",
  "t1222_Verify_your_account":"Verifiera ditt konto",
  "t1222_please_check_your_account":"Vi skickar en verifieringskod till $1, kontrollera ditt konto.",
  "t1222_I_Agree_to":"Jag godkänner $1",
  "t1223_Invalid_Verification_Code":"Ogiltig verifieringskod. Var god försök igen.",
}

//export default {
//  swMessages
//}



// WEBPACK FOOTER //
// ./src/lang/sw.js